import styled from "styled-components";

interface SelectedProps {
    className?: any,
}

export const Container = styled.div<SelectedProps>`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    gap: 8px;
    width: 100%;
    max-width: 720px;
    margin: 0 auto;
`

export const ButtonCard = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1 1 120px;
    min-width: 120px;
    height: 80px;
    padding: 12px 16px;
    background: ${(props: any) => props.theme.colors.background};
    border-radius: 12px;
    border: 2px solid ${(props: any) => props.theme.colors.white};
    color: ${({ theme }) => theme.colors.interfaceText400};
    font-size: 15px;
    font-weight: 700;
    cursor: pointer;
    transition: all .3s;
    
    &:hover {
        transform: scale(1.05);
    }
    
    &.selected {
        border: 2px solid ${({ theme }) => theme.colors.primaryRed400};
    }
    
    @media (max-width: 768px) {
        flex: 1 1 calc(50% - 4px);
        min-width: calc(50% - 4px);
        max-width: calc(50% - 4px);
        height: 72px;
        font-size: 13px;
        padding: 10px 12px;
    }
    
    @media (max-width: 480px) {
        flex: 1 1 100%;
        min-width: 100%;
        max-width: 100%;
    }
`




